import styled from 'styled-components';
import ScreenUtils from '@screen';

interface Props {
  imageSelected: boolean;
}

const GuideRailLogoContainer = styled.div<Props>`
  position: absolute;
  width: ${131 * ScreenUtils.widthRatio}px;
  height: ${197 * ScreenUtils.widthRatio}px;
  border-radius: ${20 * ScreenUtils.widthRatio}px;
  border: ${2 * ScreenUtils.widthRatio}px solid
    ${(props) => (props.imageSelected ? '#FFF' : '#787878')};
  align-content: center;
  &:hover {
    border: 2px solid white;
  }
`;

export default GuideRailLogoContainer;
